module.exports = __webpack_public_path__ + "assets/22.jpg?561f7971c5fdf22351c11db6a2a07a79";